import InfoIcon from '@mui/icons-material/InfoOutlined'
import { styled, Tooltip, IconButton } from '@mui/material'
import { useParams } from 'react-router-dom'
import { activeAlbumIdVar, drawerVar } from '../../../../../providers/apollo/cache'
import useSelectedAlbums from '../../../hooks/useSelectedAlbums'

const PillButton = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  color: '#fff',
  fontWeight: 500,
  fontSize: '0.875rem',
  cursor: 'pointer',
  gap: 8
})

export default function AlbumDetailsPillButton() {
  const { bucketId, albumId } = useParams<{ bucketId: string; albumId: string }>()
  const { selectedAlbums } = useSelectedAlbums()
  const containRootAlbum = Array.from(selectedAlbums.keys()).includes(bucketId as string)

  const toggleDrawer = () => {
    if (albumId) {
      activeAlbumIdVar(albumId)
    } else if (selectedAlbums.size > 0) {
      const firstAlbumId = Array.from(selectedAlbums.keys())[0]
      activeAlbumIdVar(firstAlbumId)
    }
    drawerVar('bucketAlbumDetails')
  }

  const disabled = containRootAlbum || !(albumId || selectedAlbums.size === 1)

  if (disabled) {
    return null
  }

  return (
    <Tooltip title="Album Details" arrow>
      <PillButton as="span">
        <IconButton
          aria-label="Album Details"
          color="primary"
          onClick={toggleDrawer}
          disabled={disabled}
          id="details-pill-button"
          data-test="details-pill-button"
          sx={{ color: '#fff' }}
        >
          <InfoIcon />
        </IconButton>
        <span style={{ color: disabled ? 'rgba(0, 0, 0, 0.38)' : '#fff' }}>Details</span>
      </PillButton>
    </Tooltip>
  )
}
